import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import {useEffect, useRef, useState} from "react";
import axiApi from "ApiCaller";
import TableChoiseIsland from "./TableChoiseIsland";
import TableCheckboxIsland from "./TableCheckboxIsland";
import ModalCreateIsland from "./ModalCreateIsland";
import {toLowCaseCleanSpaces} from "core/utils/Texts";
import IslandModel from "./IslandModel";

const ModalIslandSelect = ({showModalIsland, setShowModalIsland, multiple = false, create = true, chosenIn = [], subtitle = ""}) => {
    const [item, setItem] = useState({...IslandModel});
    const items = useRef({
        all: [],
        showed: [],
        chosen: [],
        checked: []
    })

    const [itemsShow, setItemsShow] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [checked, setChecked] = useState([]);
    useEffect(() => {
        if (chosenIn.length) {
            items.current.checked = chosenIn.map(it => it.id);
            setChecked([...items.current.checked]);
            setItemsShow([...items.current.all]);
        }
    }, [chosenIn])

    useEffect(() => {
        axiApi.get(`/api/distribution/islands/`).then((resp) => {
            items.current.all = [...resp.data.items];
            items.current.showed = [...resp.data.items];
            setItemsShow([...resp.data.items]);
        });
    }, []);


    const onSearch = (e) => {
        let items_ = items.current.all.filter(it => items.current.checked.includes(it.id));
        const valueSearched = toLowCaseCleanSpaces(e.target.value);
        if (valueSearched) {
                let filter_ = items.current.all.filter(
                    _item => toLowCaseCleanSpaces(_item.name).includes(valueSearched)
                        && !items.current.checked.includes(_item.id)
                )
            items.current.showed = [...items_, ...filter_];
        } else {
            items.current.showed = [...items.current.all];
        }
        setItemsShow([...items.current.showed]);
    };

    const openFormCreateIslands = () => {
        setShowForm(true);
    }

    const handleClose = () => {
        setShowModalIsland(false);
    }
    const handleAccept = () => {
        setShowModalIsland(false);
        if (multiple) {
            let items_ = items.current.all.filter(item => items.current.checked.includes(item.id));
            document.dispatchEvent(new CustomEvent("island:modalselect:change", {detail: items_}))
        } else {
            document.dispatchEvent(new CustomEvent("island:modalselect:change", {detail: item}))
        }
        items.current.showed = [...items.current.all];
        setItemsShow([...items.current.showed]);
    }

    return (
        <>

            {create && showForm ?
                <ModalCreateIsland
                    showForm={showForm}
                    setShowForm={setShowForm}
                    setItemsShow={setItemsShow}
                    items={items}
                />
                : <> </>}
            <Modal show={showModalIsland} onHide={handleClose} animation={true} scrollable={true}>
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="boxes-stacked"/>
                    </div>
                    <div className="preview-title d-inline-flex align-items-center">
                        <Modal.Title className="d-inline-flex ms-1">
                            <div>
                                <div className="h4 ms-0">
                                    Islas
                                </div>
                                <div className="h5 ms-0">
                                    <small>{subtitle}</small>
                                </div>
                            </div>
                        </Modal.Title>
                        {
                            create
                                ? <button className="btn btn-primary ms-5" onClick={openFormCreateIslands}>
                                    <FontAwesomeIcon icon="fa-plus"/>
                                </button>
                                : <></>
                        }
                        <form className="d-inline-flex ms-2" role="search">
                            <input className="form-control border-end-0 rounded-0" type="search"
                                   placeholder="Nombre"
                                   aria-label="Search"
                                   onChange={onSearch}
                            />
                            <span className="input-group-text bg-white border-start-0 rounded-0"
                                  id="modal-searcher-groups">
                                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass"/>
                            </span>
                        </form>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {
                        multiple
                            ? <TableCheckboxIsland
                                items={items}
                                itemsShow={itemsShow}
                                checked={checked}
                                setChecked={setChecked}
                            />
                            : <TableChoiseIsland
                                items={items}
                                itemsShow={itemsShow}
                                setItem={setItem}
                            />
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Descartar
                    </Button>
                    <Button variant="primary" onClick={handleAccept}>
                        Seleccionar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ModalIslandSelect